<template>
    <TableOfContents
        class="microlearning-toc"
        :header="course.title"
        headerIcon="graduation-cap"
        :disabled="isDemo"
        @click="switchToMicroLearningOverView"
    >
        <dl
            class="accordion box"
            role="presentation"
        >
        <TotemAccordionItem
            :item="microLearningElement"
            theme="micro-learning-toc"
            :key="elementId"
            v-for="(microLearningElement, elementId) in groupedMicroLearningElements"
            :disabled="isDemo"
            ref="microlearningElements"
        >
            <template #header>
                <div class="microlearning-title">
                    <span class="microlearning-title__icon icon-cubes"></span>
                    <div class="microlearning-title__label-container">
                        <span class="microlearning-title__label">
                            {{ microLearningElement.title }}
                        </span>
                        <span class="microlearning-title__time">
                            {{ convertTimeToMinutesAndHoursForElement(microLearningElement) }}
                        </span>
                    </div>
                </div>
            </template>
            <template #content>
                <MicroLearningItem
                    v-for="(microLearningSection, index) in microLearningElement.sections"
                    :key="index"
                    :time="microLearningSection.duration"
                    :title="microLearningSection.title"
                    :disabled="isDemo"
                    :sectionType="microLearningSection.type"
                    :section="microLearningSection"
                    v-on:reInitializeVideo="reInitializeVideo"
                    :allCurrentlyWatchedSequences="allCurrentlyWatchedSequences"
                />
            </template>
        </TotemAccordionItem>
        </dl>
    </TableOfContents>
</template>

<script>
    import { mapGetters } from 'vuex'
    import TableOfContents from 'components/coursepage/microlearning/TableOfContents'
    import MicroLearningItem from 'components/coursepage/microlearning/tableofcontents/MicroLearningTableOfContentsItem'
    import microLearningHelper from 'components/shared/mixins/microLearningHelper'
    import routeHelper from 'components/shared/mixins/routeHelper'

    export default {
        name: 'MicroLearningTableOfContents',
        mixins: [microLearningHelper, routeHelper],
        components: {
            TableOfContents,
            MicroLearningItem,
        },
        props: {
            course: Object
        },
        computed: {
            ...mapGetters({
                isLoggedIn: 'isLoggedIn',
                allCurrentlyWatchedSequences: 'VideoPlayer/allWatchedSequences',
                currentMicroLearningSection: 'MicroLearning/getMicroLearningSection'
            }),
            isDemo () {
                return !!this.course.demo
            }
        },
        methods: {
            isLinkToVideo (timeLink) {
                return timeLink.time !== ''
            },
            convertTimeToSeconds (time) {
                let splittedTime = time.split(':')
                let hoursInseconds = (parseInt(splittedTime[0]) * 60 * 60)
                let minutesInseconds = (parseInt(splittedTime[1]) * 60)
                let seconds = parseInt(splittedTime[2])
                return hoursInseconds + minutesInseconds + seconds
            },
            switchToMicroLearningOverView () {
                this.$store.dispatch('MicroLearning/assignMicroLearningSection', null)
            },
            reInitializeVideo () {
                this.$emit('reInitializeVideo')
            },
            openAccordionWithMicroLearningSection (elementId) {
                this.$refs.microlearningElements.find(microLearningElement => {
                    return microLearningElement.item.sections.find(microLearningSection => microLearningSection.elementId === elementId)
                }).isActive = true
            }
        },
        watch: {
            currentMicroLearningSection: {
                handler () {
                    if (this.currentMicroLearningSection) {
                        this.openAccordionWithMicroLearningSection(this.currentMicroLearningSection.elementId)
                    }
                }
            }
        }
    }

</script>

<style lang="scss" scoped>
    dl {
        margin: 0;
    }
    .microlearning-title {
        display: flex;
        align-items: center;
        padding: 5px 0;
        font-family: Quicksand-Bold, sans-serif;
        font-size: 1.4rem;

        &__icon {
            color: $orange;
            margin: 0 15px 0 0;
            font-size: 1.8rem;
        }
        &__label-container {
            flex-direction: column;
            display: flex;
            align-items: flex-start;
        }
        &__time {
            color: $silver;
            font-size: 1.3rem;
            font-family: Quicksand-Regular, sans-serif;
        }
        &__label {
            text-align: left;
            padding: 0px 35px 0px 0px;
        }
    }
</style>
